import type { PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "services/api.ts";
import { fetchConstantsAndUpdateStore } from "./sharedSlice";
import type { ClaimsDataType } from "types/DataTypes.ts";

const claimsFormSlice = createSlice({
  name: "claimsForm",
  initialState: {
    claimsFormData: null,
    currentClaim: null,
    constants: null,
    rreIdToFilterBy: undefined,
  },
  reducers: {
    setClaimsFormData: (state, action: PayloadAction<ClaimsDataType>) => {
      state.claimsFormData = { ...state.claimsFormData, ...action.payload };
    },
    setCurrentClaim: (state, action) => {
      state.currentClaim = {
        ...state.currentClaim,
        ...action.payload,
      };
    },
    setRreIdToFilterBy: (state, action: PayloadAction<number | undefined>) => {
      state.rreIdToFilterBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchClaimAndUpdateStore.fulfilled,
      (state, action: PayloadAction<ClaimsDataType>) => {
        state.currentClaim = action.payload;
      },
    );
    builder.addCase(
      fetchConstantsAndUpdateStore.fulfilled,
      (state, action: PayloadAction<ClaimsDataType>) => {
        state.constants = action.payload;
      },
    );
  },
});

export const fetchClaimAndUpdateStore = createAsyncThunk(
  "claim/fetchClaimAndUpdateStore",
  async (
    { accessToken, id }: { accessToken: string; id: string },
    { dispatch },
  ) => {
    const result = await dispatch(
      // @ts-expect-error TODO: fix this
      api.endpoints.getClaimById.initiate({ accessToken, id }),
    );
    if ("data" in result) {
      return result.data;
    }
    throw new Error(
      `Failed to fetch claim data for id ${id}. Check the validity of the id.`,
    );
  },
);

export const { setClaimsFormData, setCurrentClaim, setRreIdToFilterBy } =
  claimsFormSlice.actions;
export default claimsFormSlice.reducer;
